<template>
    <div class="col-sm-12" style="">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="min-height: calc(100vh - 218px);max-height:auto;background: white;">
            <div class="col-sm-12 sparkline12-list">
                <div class="sparkline12-hd col-sm-12" style="padding:0">
                    <Windows
                        :data="windows"
                        @clickWindow="clickWindow"
                    />
                    <CreateDocents
                        v-if="windows[0].active"
                        @buttonActions="buttonActions"
                        :dataUser="dataUser"
                        :loadRegister="loadRegister"
                    />
                    <Tables
                        v-if="windows[1].active"
                        :dataT="data_table"
                        @edit="editUser"
                        @delete="deleteUsr"
                        @sendEmail="sendEmail"
                    />
                    <GestionMasiva
                        v-if="windows[2].active"
                        title="Cargar todos los docentes"
                        :data="gestionMas"
                        :st="st"
                        @buttonActions="buttonActions"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CreateDocents from '@/views/teachers/components/createUsers.vue'
import Windows from '@/components/Scheduler/Windows.vue'
import Tables from '@/components/Scheduler/Tables.vue'
import GestionMasiva from '@/components/Scheduler/GestionMasiva.vue'
export default{
    props:['st','outPutBackend'],
    data(){
        return{
            show:false,
            loadRegister:false,
            windows:[
                {
                    id:1,
                    label:'Gestión',
                    active:true
                },
                {
                    id:2,
                    label:'Listados',
                    active:false
                },
                {
                    id:3,
                    label:'Gestión masiva',
                    active:false
                }
            ],
            teacher_rol:false,
            instituto_rol:false,
            send_horario:[],
            dataUser:{},
            gestionMas:[
                {
                    label: 'NO. IDENTIFICACIÓN',
                    content: 'Cédula de ciudadania del docente'
                },
                {
                    label: 'NOMBRES',
                    content: 'Nombres del docente, sin apellidos'
                },
                {
                    label: 'APELLIDOS',
                    content: 'Apellidos del docente'
                },
                {
                    label: 'FECHA DE NACIMIENTO',
                    content: 'La fecha de nacimiento del docente en el formato: AAAA-MM-DD (1977-07-13)'
                },
                {
                    label: 'GENERO',
                    content: 'F Si es maestra, M Si es profesor, I Si es indefinido'
                },
                {
                    label: 'TITULO O PROFESIÓN',
                    content: 'Titulo del docente'
                },
                {
                    label: 'DIRECCIÓN',
                    content: 'Dirección de domicilio del docente'
                },
                {
                    label: 'TELÉFONO',
                    content: 'Teléfono de contacto principal del docente'
                },
                {
                    label: 'MAIL',
                    content: 'Correo electrónico del docente'
                },
            ],
            data_table:{
                head:['#','Docente','Identificación','Teléfonos','Correo electronico','Acciones'],
                rows:[]
            }
        }
    },
    components:{
        CreateDocents,
        Windows,
        Tables,
        GestionMasiva
    },
    watch:{
        outPutBackend:{
            handler(){
                let response = this.outPutBackend
                switch(response.identify){
                    case 'new_user':
                        this.returnTeachers();
                        this.loadRegister = false
                        this.$swal(
                            {
                                icon: 'success',
                                title: 'Registro exitoso',
                                text: `Se registro correctamente la persona "${response.data.sub.first_name} ${response.data.sub.last_name}"`,
                            }
                        );
                    break;
                    case 'edit_user':
                        //console.log('edit_user',response)
                        this.returnTeachers();
                        this.loadRegister = false
                        this.$swal(
                            {
                                icon: 'success',
                                title: 'Edición exitosa',
                                text: `Se edito correctamente la persona "${response.data.sub.first_name} ${response.data.sub.last_name}"`,
                            }
                        );
                    break;
                    case 'delete_user':
                        //this.data_teachers = this.data_teachers.filter(item=> item.id != response.data.sub.aedocentes_id)
                        for(const i in this.data_table.rows){
                            if(`${this.data_table.rows[i].allData.aedocentes_id}` === `${response.data.sub.aedocentes_id}`){
                                this.data_table.rows.splice(i,1)
                            }
                        }

                        let arr = JSON.parse(JSON.stringify(this.data_table))
                        this.data_table.rows = {}
                        this.data_table = arr

                        //this.returnTeachers();
                        this.$swal(
                            {
                                icon: 'success',
                                title: 'Eliminación con exito',
                                text: `Se eliminó la persona "${response.data.sub.aedocentes_nombres} ${response.data.sub.aedocentes_apellidos}" correctamente`,
                            }
                        );
                    break;
                    case 'allteachers':
                        this.data_table = {
                            head:['#','Docente','Identificación','Teléfonos','Correo electronico','Acciones'],
                            width:[50,230],
                            rows:[]
                        }
                        for(const i in response.data.sub){
                            this.data_table.rows.push(
                                {
                                    0:parseInt(i)+1,
                                    1:response.data.sub[i].aedocentes_nombres+' '+response.data.sub[i].aedocentes_apellidos,
                                    2:response.data.sub[i].aeusu_llave,
                                    3:response.data.sub[i].aedocentes_telefono,
                                    4:response.data.sub[i].aedocentes_mail,
                                    5:[true,true,true],
                                    allData:response.data.sub[i]
                                }
                            )
                        }
                    break;
                    case 'select_horario':
                        this.send_horario = []
                        this.show = true
                        for(const i in response.data.sub){
                             this.send_horario.push(
                                {
                                id:response.data.sub[i].horariode,
                                name:response.data.sub[i].aeasignaciones_hora,
                                last_name:'',
                                identification:response.data.sub[i].docente,
                                phone:response.data.sub[i].aeasignaciones_asignatura,
                                email:response.data.sub[i].aeasignaciones_enlace
                                }
                            )
                        }
                    break;
                    case 'sendEmail':
                        this.$swal(
                            {
                                icon: 'success',
                                title: 'Envío exitoso',
                                text: `Se envio correctamente el correo electronico`,
                            }
                        );
                    break;
                }
            }
        }
    },
    methods:{
        sendEmail(data){

            console.log(data)

            let formData = new FormData();

            formData.append('id_docente',data.aedocentes_id)
            formData.append('id_usuario',data.aeusu_id)

            this.$emit('goBackend',{
                route:'/users/rememberpass',
                method:'POST',
                identify:'sendEmail',
                data: formData
            })
        },
        deleteUsr(data){
            //console.log('deleteUsr',this.st.personLog.sub.datos_user.aeusu_id,data.aedocentes_id)
            /**/

            this.$swal({
                title: '¿Estás seguro/a de eliminar este usuario?',
                text: "Una vez eliminado no podra recuperar el usuario",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, Eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    let formDataDelete = new FormData();
                    formDataDelete.append('id',parseInt(data.aedocentes_id));
                    this.$emit('goBackend',{
                        route:'/teachers/delteachers',
                        method:'PUT',
                        identify:'delete_user',
                        data: formDataDelete
                    })
                }
            })
        },
        editUser(data){
            this.windows[0].active = true
            this.windows[1].active = false
            this.windows[2].active = false
            this.dataUser = data
        },
        clickWindow(data){
            for(const i in this.windows){
                if(`${data.data.id}` === `${this.windows[i].id}`){
                    this.windows[i].active = true
                }else{
                    this.windows[i].active = false
                }
            }
            if(data.data.id === 1){
                this.loadRegister = false
            }
        },
        buttonActions(caso,dataComponent){
            switch(caso){
                case 'save_user':
                    let formDataNewUser = new FormData();
                    formDataNewUser.append('first_name',dataComponent.data.name)
                    formDataNewUser.append('last_name',dataComponent.data.last_name)
                    formDataNewUser.append('date_birth',dataComponent.data.date_birth)
                    formDataNewUser.append('direction',dataComponent.data.direction)
                    formDataNewUser.append('email',dataComponent.data.email)
                    formDataNewUser.append('gender',dataComponent.data.gender)
                    formDataNewUser.append('number_identification',dataComponent.data.number_identification)
                    formDataNewUser.append('phone',dataComponent.data.phone)
                    this.$emit('goBackend',{
                        route:'/users/registro',
                        method:'POST',
                        identify:'new_user',
                        data: formDataNewUser
                    })
                    this.loadRegister = true
                break;
                case 'edit_user':
                    //console.log(dataComponent.data)
                    let formDataEditUser = new FormData();
                    formDataEditUser.append('id',dataComponent.data.id)
                    formDataEditUser.append('first_name',dataComponent.data.name)
                    formDataEditUser.append('last_name',dataComponent.data.last_name)
                    formDataEditUser.append('date_birth',dataComponent.data.date_birth)
                    formDataEditUser.append('direction',dataComponent.data.direction)
                    formDataEditUser.append('email',dataComponent.data.email)
                    formDataEditUser.append('gender',dataComponent.data.gender)
                    formDataEditUser.append('number_identification',dataComponent.data.number_identification)
                    formDataEditUser.append('phone',dataComponent.data.phone)
                    this.$emit('goBackend',{
                        route:'/teachers/UpdateDocents',
                        method:'PUT',
                        identify:'edit_user',
                        data: formDataEditUser
                    })
                    this.loadRegister = true
                break;
                case 'uploadCsv':
                    console.log(dataComponent.data)
                break;
            }
        },
        returnTeachers(){
                //console.log('holaa');
                //this.instituto_rol = true
            let formData = new FormData();
            formData.append('id_institucion',`${this.st.personLog.sub.datos_usuario.id_institucion}`)
            formData.append('id_usu',`${this.st.personLog.sub.datos_usuario.id_usuario}`)
            formData.append('ano_lectivo',`${this.st.personLog.sub.datos_usuario.id_anolectivo}`)
            formData.append('rol',`${this.st.personLog.sub.datos_usuario.rol}`)
            this.instituto_rol = true
            this.$emit('goBackend',{
                route:'/teachers/allteachers',
                method:'POST',
                identify:'allteachers',
                data: formData
            })
        }
    },
    beforeMount(){
        this.returnTeachers();
    }
}
</script>
